import {
  ErrorMessage,
  FieldLabel,
  FieldValue,
  TextInput,
} from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import classNames from 'classnames'

import React from 'react'
import { ApiCustomer } from '@vend/types'
import { ContactNumber } from '../../../../react/modals/common/ContactNumber'
import { CONTACT_OPTIONS } from '../../../../react/modals/common/types'
import { getDefaultContactOption } from '../../../../react/modals/common/customer-contact-utils'

export type Props = {
  customer: ApiCustomer | null
  onEmailChange: (email: string) => void
  onPhoneNumberChange: (phoneNumberType: string, phoneNumber: string) => void
  isEmailInvalid: boolean
}

export const LineItemFulfilmentCustomerContactView: React.FC<Props> = ({
  customer,
  onEmailChange,
  onPhoneNumberChange,
  isEmailInvalid,
}) => {
  const t = useT()
  return (
    <>
      <FieldLabel label={t('Contact number')}>
        <FieldValue>
          <ContactNumber
            customer={customer}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              onPhoneNumberChange(e.target.name, e.target.value)
            }}
            defaultOption={getDefaultContactOption(customer)}
          />
        </FieldValue>
      </FieldLabel>
      <FieldLabel label={t('Email')}>
        <FieldValue>
          <TextInput
            className={classNames('vd-input', {
              'vd-input--error': isEmailInvalid,
            })}
            placeholder={t('Enter email')}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              onEmailChange(e.target.value)
            }}
            name={CONTACT_OPTIONS.EMAIL}
            value={customer?.email || ''}
          />
        </FieldValue>
        {isEmailInvalid && (
          <ErrorMessage>
            {t('Enter a valid email address', {
              _context: 'Error message for customer step in service modal.',
            })}
          </ErrorMessage>
        )}
      </FieldLabel>
    </>
  )
}
